<dx-data-grid
  #dataGrid
  class="custom-grid"
  [class.allow-editing]="allowDataEditing"
  [dataSource]="data"
  keyExpr="id"
  [showBorders]="false"
  [showColumnLines]="false"
  [showRowLines]="showRowLines"
  [hoverStateEnabled]="true"
  (onSelectionChanged)="onRowSelected($event)"
  (onRowClick)="onRowClickHandler($event)"
  (onRowUpdated)="onRowUpdateHandler($event)"
  (onRowPrepared)="onRowPrepared($event)"
  (onEditCanceled)="onRowUpdateCancelledHandler()"
  (onEditingStart)="onRowEditingStartHandler($event)"
  (onSaving)="onRowUpdateSavedHandler()"
  [columnAutoWidth]="true"
  [allowColumnResizing]="true"
  [sorting]="disableSorting ? { mode: 'none' } : { mode: 'multiple' }"
  [columnResizingMode]="'nextColumn'"
  (onExporting)="onExporting($event)"
  [paging]="{ enabled: showPagination }"
  [remoteOperations]="isServerSide"
  [scrolling]="{
    mode: 'standard',
    showScrollbar: 'always',
    useNative: false,
    scrollByThumb: true,
    scrollByContent: true
  }"
  (onContentReady)="onContentReady($event)"
>
  <dxo-header-filter [visible]="!disableFiltering"></dxo-header-filter>
  <dxo-filter-panel 
    [visible]="showFilterPanel"
    [customizeText]="customizeFilterPanelText"
  ></dxo-filter-panel>
  <dxo-toolbar>
    <dxi-item *ngIf="showGrouping" location="before" width="100%">
      <div *dxTemplate>
        <dx-select-box
          class="table-grouping"
          width="225"
          [items]="groupingValues"
          [inputAttr]="{ 'aria-label': 'Value' }"
          displayExpr="text"
          valueExpr="value"
          labelMode="floating"
          stylingMode="outlined"
          placeholder=""
          [label]="'COMMON.GROUP-BY' | translate"
          [value]="selectedGrouping"
          (onValueChanged)="toggleGroupColumn($event)"
        >
        </dx-select-box>
      </div>
    </dxi-item>
    <dxi-item *ngIf="showSearch" location="after">
      <div *dxTemplate>
        <dx-text-box
          #searchInputBox
          icon="search"
          [width]="'100%'"
          [label]="searchPlacehoder"
          stylingMode="filled"
          labelMode="floating"
          stylingMode="outlined"
          [value]="searchValue"
          valueChangeEvent="input"
          (onValueChanged)="onTableSearch($event)"
          class="search-box"
        >
          <dxi-button
            name="search"
            type="danger"
            location="before"
            [options]="{ icon: 'search', type: 'default', disabled: true }"
          ></dxi-button>
        </dx-text-box>
      </div>
    </dxi-item>
    <dxi-item *ngIf="showActionButton" location="after">
      <div *dxTemplate>
        <dx-button
          class="cta-btn"
          type="default"
          [icon]="actionButtonIcon"
          [text]="actionButtonText!"
          (click)="actionFunction.emit()"
        ></dx-button>
      </div>
    </dxi-item>
    <dxi-item *ngIf="showExport" location="after">
      <div *dxTemplate>
        <dx-button
          class="cta-btn"
          type="default"
          (click)="onExporting($event)"
          >{{ "COMMON.EXPORT-TO-EXCEL" | translate }}</dx-button
        >
      </div>
    </dxi-item>
  </dxo-toolbar>
  <dxo-state-storing
    *ngIf="stateKey"
    [enabled]="true"
    type="custom"
    [customLoad]="loadGridState"
    [customSave]="saveGridState">
  </dxo-state-storing>
  <dxo-editing mode="row" [allowUpdating]="allowDataEditing" [useIcons]="true">
  </dxo-editing>
  <dxo-paging [pageSize]="pageSize"> </dxo-paging>
  <dxo-pager
    [allowedPageSizes]="allowedPageSizes"
    displayMode="full"
    [visible]="showPagination"
    [showInfo]="true"
    [showPageSizeSelector]="showPageSizeSelector"
    [showNavigationButtons]="true"
  >
  </dxo-pager>
  <dxo-selection
    *ngIf="showSelection"
    [mode]="selectionMode"
    showCheckBoxesMode="always"
  ></dxo-selection>
  <dxo-data-grid-master-detail
    *ngIf="showRowDetails"
    [enabled]="true"
    [autoExpandAll]="false"
    [template]="'masterDetailTemplate'"
  ></dxo-data-grid-master-detail>

  <div *dxTemplate="let row of 'masterDetailTemplate'">
    <ng-container *ngIf="rowHasDetails?.(row.data) && rowDetailTemplate">
      <ng-container
        *ngTemplateOutlet="rowDetailTemplate; context: { $implicit: row.data }"
      ></ng-container>
    </ng-container>
  </div>

  <dxi-column
    *ngFor="let column of columns; let i = index"
    [cellTemplate]="null"
    [cssClass]="'table-cell' + (column.cssClass ? ' ' + column.cssClass : '')"
    [caption]="column.caption"
    [name]="column.name || null"
    [dataField]="column.dataField"
    [cellTemplate]="column.cellTemplate"
    [allowFiltering]="column.disableFiltering ? false : true"
    [allowSearch]="true"
    [allowSorting]="column.allowSorting ? false : true"
    [calculateFilterExpression]="
      column.filterExpression
        ? column.filterExpression
        : calculateFilterExpressionDefault
    "
    [calculateCellValue]="
      column.cellValue ? column.cellValue : calculateCellValueDefault
    "
    [dataType]="column.cellType"
    [calculateDisplayValue]="column.calculateDisplayValue"
    [calculateSortValue]="column.calculateSortValue"
    [allowEditing]="column.allowEditing ? true : false"
    [visible]="column.visible !== false"
  >
    <dxo-header-filter
      *ngIf="column.headerFilter"
      [dataSource]="column.headerFilter"
    ></dxo-header-filter>
    <ng-container *ngIf="column.actions">
      <div *dxTemplate="let data of column.cellTemplate" class="actions-cell">
        <ng-container *ngFor="let action of column.actions">
          @if(action.isShowAction(data.value)) {
            @if(action.isButton && action.text) {
              <div class="action-button">
                <dx-button
                  [type]="action.buttonType ?? 'normal'"
                  [disabled]="
                    action.isDisabledAction
                      ? action.isDisabledAction(data.value)
                      : false
                  "
                  [text]="action.text"
                  [hint]="action.hint"
                  (click)="action.onClick(data.value, $event)"
                  [class]="action.class || ''"
                >
                </dx-button>
              </div>
            } @else if(action.icon) {
              <div class="action-icon">
                <dx-button
                  type="default"
                  [disabled]="
                    action.isDisabledAction
                      ? action.isDisabledAction(data.value)
                      : false
                  "
                  [icon]="action.icon || ''"
                  [hint]="action.hint"
                  (click)="action.onClick(data.value, $event)"
                  [class]="action.class || ''"
                >
                </dx-button>
              </div>
            } @else if(action.text) {
              <span>
                {{ action.text }}
              </span>
            }
          }
        </ng-container>
      </div>
    </ng-container>
    <ng-container
      *ngIf="column.cellTemplate && column.cellTemplate == 'progressBullet'"
    >
      <div *dxTemplate="let data of column.cellTemplate">
        @if(data.value !== undefined && data.value !== null) {
          <dx-bullet
            [color]="getBulletColor(data.value)"
            [showTarget]="false"
            [showZeroLevel]="true"
            [startScaleValue]="0"
            [endScaleValue]="100"
            [value]="data.value"
            [tooltip]="{ enabled: false }"
          >
            <dxo-size [width]="150" [height]="35"></dxo-size>
            <dxo-margin [top]="5" [bottom]="0" [left]="5"></dxo-margin>
          </dx-bullet>
        }
      </div>
    </ng-container>
    <ng-container *ngIf="column.cellTemplate && column.cellTemplate == 'link'">
      <div *dxTemplate="let data of column.cellTemplate">
        <a [routerLink]="data.data.link">{{ data.value }}</a>
      </div>
    </ng-container>
    <ng-container *ngIf="column.cellTemplate && column.cellTemplate == 'image'">
      <div *dxTemplate="let data of column.cellTemplate">
        @if(data.value) {
          <img 
            [src]="data.value" 
            [class]="column.cssClass ?? 'image-cell'"
            alt="image"
          />
        }
      </div>
    </ng-container>
    <ng-container *ngIf="column.cellTemplate && column.cellTemplate == 'description'">
      <div *dxTemplate="let data of column.cellTemplate">
        <div [class]="column.cssClass ?? 'description-cell'">
          <div 
            class="description-wrapper"
            [style.--line-clamp]="data.value.maxLines ?? defaultDescriptionLines"
          >
            {{ data.value.value }}
          </div>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="column.cellTemplate && column.cellTemplate == 'titleDescription'">
      <div *dxTemplate="let data of column.cellTemplate">
        <div [class]="column.cssClass ?? 'title-description-cell'">
          <p class="title-cell">
            {{ data.displayValue.title }}
          </p>
          @if(data.displayValue.description)
          {
            <div 
              class="description-wrapper" 
              [style.--line-clamp]="data.displayValue.maxDescriptionLines ?? defaultDescriptionLines"
            >
              {{ data.displayValue.description }}
            </div>
          }
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="column.cellTemplate && templates[column.cellTemplate]">
      <div *dxTemplate="let data of column.cellTemplate">
        <ng-container
          *ngTemplateOutlet="templates[column.cellTemplate]; context: { $implicit: data }"
        ></ng-container>
      </div>
    </ng-container>
    <ng-container *ngIf="column.cellTemplate && column.cellTemplate == 'percent'">
      <div *dxTemplate="let data of column.cellTemplate">
        <div [class]="'percent-cell ' + (column.cssClass || '')">
          @if(data.value == 0) {
            <span> {{ data.value }}</span>
          } @else {
            @if(data.value > 0) {
              <span class="positive">+{{ data.value }}%</span>
            } @else {
              <span class="negative">{{ data.value }}%</span>
            }
          }
        </div>
      </div>
    </ng-container>
  </dxi-column>
  <!-- <dxo-export [enabled]="showExport" [allowExportSelectedData]="false"></dxo-export> -->
</dx-data-grid>